// TSS vite/03 §"Query keys convention".

export const repositoryKeys = {
    standards: ['repository-standards'],
    standard: (id) => ['repository-standards', 'detail', id],
    standardVersions: (id) => ['repository-standards', 'versions', id],
    standardVersion: (id) => ['repository-standards', 'version', id],
    all:     ['repositories'],
    list:    (params) => ['repositories', 'list', params],
    detail:  (id)     => ['repositories', 'detail', id],
    // Environments hang off their repository, and deployments off their
    // environment, so one write does not throw away the other's cache.
    environments: (repositoryId)  => ['repositories', 'detail', repositoryId, 'environments'],
    deployments:  (environmentId) => ['environments', environmentId, 'deployments'],
};
